module.exports = "<div *ngFor=\"let attribute of attributeConfig\" class=\"attribute-cell\">\r\n  <div class=\"cell-header\">{{ attribute.label }}</div>\r\n  <div class=\"cell-data\">{{  thing && thing.attributes && thing.attributes[attribute.key] | formatThingAttribute : attribute.type }}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/things/attributes/attributes.component.html
// module id = ../../../../../src/app/components/things/attributes/attributes.component.html
// module chunks = main